import { onScopeDispose } from 'vue';

/** True when the key press is aimed at a text field, where shortcuts must not fire. */
export function isTyping(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName);
}

/** A single-key shortcut (no modifiers), ignored while typing. */
export function useShortcut(
  key: string,
  handler: () => void,
  target: Pick<Window, 'addEventListener' | 'removeEventListener'> = window,
): void {
  const listener = (event: Event) => {
    const e = event as KeyboardEvent;
    if (e.key !== key || e.metaKey || e.ctrlKey || e.altKey || isTyping(e.target)) return;
    e.preventDefault();
    handler();
  };
  target.addEventListener('keydown', listener);
  onScopeDispose(() => target.removeEventListener('keydown', listener));
}
